import React from 'react';

const inputStyles = {
  backgroundColor: ' #fefefe',
  border: '1px solid #ccc',
  color: '#0a0a0a',
  fontSize: '14px',
} as React.CSSProperties;

export const ProductDropdown: React.FC<any> = ({ handleSelectedProduct, products, selectedProduct, selectIndex }) => {
  return (
    <div className="input-container flex flex-col mb-2">
      <select
        className="relative w-full h-8 box-border block overflow-visible p-1 mb-2 text-base rounded"
        id={`select_index_${selectIndex}`}
        key={selectIndex}
        name="product_item"
        onChange={e => {
          handleSelectedProduct(e.target.value, selectIndex);
        }}
        style={inputStyles}
        value={selectedProduct.id}
      >
        {products &&
          Object.keys(products).map(key => {
            return (
              <option key={products[key].id} value={products[key].id}>
                {products[key].name}
              </option>
            );
          })}
      </select>
    </div>
  );
};
